window.ProfileMatchingAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.LOAD_STATUSES = {
        NOT_LOADED: 'NOT_LOADED',
        COMPLETED: 'COMPLETED',
        IN_PROGRESS: 'IN_PROGRESS',
        PENDING: 'PENDING',
    }

    _protected.setApiUrl(publicConfiguration.getBaseAPI('ProfileMatching'));

    self.getProfilesScores = function (brandId, jobId) {
        var defer = $q.defer();

        _protected.request("v1/core/brands/" + brandId + "/jobs/" + jobId + "/scores", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    console.error(res);
                    defer.resolve([]);
                }
            }, function (err) {
                console.error(err);
                defer.resolve([]);
            });

        return defer.promise;
    };

    self.getTopProfiles = function (brandId, jobId, topN) {
        var defer = $q.defer();

        _protected.request("v1/core/brands/" + brandId + "/jobs/" + jobId + "/top_candidates", "GET", { top_n: topN })
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    console.error(res);
                    defer.resolve([]);
                }
            }, function (err) {
                console.error(err);
                defer.resolve([]);
            });

        return defer.promise;
    };

    self.getProfileMatchingInfo = function (brandId, jobId, jobApplicationId) {
        var defer = $q.defer();

        _protected.request("v1/core/brands/" + brandId + "/jobs/" + jobId + "/candidate_card", "GET", {job_application_id: jobApplicationId})
            .then(function (res) {
                if (res.status === 200 && res?.data?.data) {
                    defer.resolve(res.data.data);
                } else {
                    console.error(res);
                    defer.resolve([]);
                }
            }, function (err) {
                console.error(err);
                defer.resolve([]);
            });

        return defer.promise;
    };

    self.getTopCandidates = async (brandId, jobId, params) => {
        const response = await _protected.request(`v1/brands/${brandId}/jobs/${jobId}/applications`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.removeCandidate = async (brandId, jobId, payload) => {
        const response = await _protected.request(`v1/core/brands/${brandId}/jobs/${jobId}/remove_candidate`, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getJobAssignees = async (brandId, jobId, params) => {
        const response = await _protected.request(`v1/core/brands/${brandId}/jobs/${jobId}/talent_pool_candidate_card`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getComponentFeedback = async (brandId, jobId, params) => {
        const response = await _protected.request(`v1/core/brands/${brandId}/jobs/${jobId}/get_component_feedback`, 'GET', params);

        if (response?.status === 200 && response?.data) {
            return response.data;
        }

        if (response?.status === 204) {
            return [];
        }

        throw response;
    };

    self.postComponentFeedback = async (brandId, jobId, jobApplicationId, payload) => {
        const response = await _protected.request(`v1/core/brands/${brandId}/jobs/${jobId}/component_feedback?job_application_id=${jobApplicationId}`, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getLoadStatusAwareness = async function (brandId) {
        try {
            const res = await _protected.request("v1/core/brands/" + brandId + "/load_status", "GET");
            if (res.data && res.data.data) {
                return res.data.data;
            } else {
                console.error(res);
                return [];
            }
        } catch (err) {
            console.error(err);
            return [];
        }
    };
});
